$(function () {

		if ($('.service-review-list').length > 0 && !is_tablet) {
			$('.service-review-list').owlCarousel({
				items: 1,
				loop: true,
				margin: 64,
				nav: true,
				smartSpeed: 500,
				dots: false,
				slideTransition: "cubic-bezier(0.65,0.05,0.36,1)",
				responsive: {
					0: {
						items: 1.2,
						margin: 20,
						nav: false
					},
					1023: {
						margin: 26,
					},
					1023: {
						margin: 64,
						items: 2,
					},
				}
			});
		}

});